import { EntityId } from './entity-id'
import { EntityType } from '../entity-type.models'

class TenantProfileId implements EntityId {
  entityType = EntityType.TENANT_PROFILE
  id: string
  constructor(id: string) {
    this.id = id
  }
}

export default TenantProfileId
